import { render, staticRenderFns } from "./tabZujianChild4.vue?vue&type=template&id=1a38f1de&"
import script from "./tabZujianChild4.vue?vue&type=script&lang=js&"
export * from "./tabZujianChild4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabZujianChild4.vue"
export default component.exports